{
  "0a426a7cf7035aba": "¿No puedes encontrar lo que buscas?",
  "0cf8e2a03758919e": "Ayuda por tema",
  "1174e465a7c77f38": "Cargando el Centro de Ayuda",
  "21e344a9d52f4984": "Contacta directamente con el soporte y te ayudaremos de inmediato.",
  "2217586c67cc8dd5": "Abre la biblioteca de soporte completa.",
  "2dd25cabbad6c9c2": "Contactos dedicados",
  "4cc03b1d39867d97": "Abrir el Centro de Ayuda",
  "4f6bbf0f453c2c4f": "Descarga nuestra aplicación móvil para gestionar tu horario, publicar turnos y enviar mensajes a tus trabajadores en cualquier lugar.",
  "617630ea4d370ebc": "Buscar artículos...",
  "6b491c7346cc1fdd": "Enviar una solicitud",
  "7b1c58a64d814c47": "Llamar al soporte 24/7",
  "7b56e0d0b308abe4": "¿Cómo podemos ayudar?",
  "88caafee4e66991a": "Habla con el soporte en cualquier momento.",
  "8f0e6ece108b7b9c": "Elige un tema a continuación para encontrar respuestas e instrucciones.",
  "917e144e4bc3da89": "Enviar solicitud",
  "a0ccee4b426b3aa7": "Error al cargar los artículos de soporte.",
  "a60530deb3fa0a97": "Representante de facturación",
  "a7156767610022e1": "No hay artículos de soporte que coincidan con tu búsqueda actual.",
  "a78cebc44214256b": "Centro de ayuda",
  "cb51da6d9dfab99d": "Explorar todos los artículos",
  "ccc498b77ae62cf8": "Gerente de cuentas",
  "d6e0a09ea9a50e52": "Abriendo el Centro de Ayuda…",
  "d86f74b180c59e24": "Llamar al soporte",
  "d968ef24f7787160": "Escanea para descargar",
  "d9db9c736ed99c3f": "Obtén respuestas sobre la gestión de turnos, la coordinación de trabajadores y la solución de problemas en tu cuenta.",
  "dd1ffc861bb9cd27": "Los miembros de tu equipo dedicado de Clipboard Health.",
  "e09e173ffdea2f37": "Ponte en contacto con el soporte directamente y te ayudaremos de inmediato.",
  "e28362912cdcde21": "No hay artículos de soporte disponibles en este momento.",
  "efd29d8c54d0a8ff": "Lleva Clipboard contigo",
  "fc1c61ecc2038c73": "Envía los detalles y haremos un seguimiento."
}
